import {
  createContext,
  useContext,
  useState,
  ReactNode,
  Dispatch,
  SetStateAction,
  useEffect,
} from "react";
import { api } from "../../Services/api";
import { IProductAPI } from "../../Interfaces";
import { toast } from "react-toastify";

interface IProductsProviderData {
  products: IProductAPI[];
  setProducts: Dispatch<SetStateAction<IProductAPI[]>>;
  getProducts: () => void;
  addNewProduct: (product: IProductAPI) => void;
  deleteProduct: (id: number | undefined) => void;
  editProduct: (service: IProductAPI) => void;
}

interface ProductsProps {
  children: ReactNode;
}

const ProductsContext = createContext<IProductsProviderData>(
  {} as IProductsProviderData
);

export const ProductsProvider = ({ children }: ProductsProps) => {
  const [products, setProducts] = useState<IProductAPI[]>([]);

  useEffect(() => {
    api
      .get("/products")
      .then((response) => setProducts([...response.data]))
  }, []);

  const getProducts = () => {
    api
      .get("/products")
      .then((response) => setProducts([...response.data]))
      .catch((_) => toast.error("Erro ao carregar produtos"));
  };

  const addNewProduct = (productToBeAdd: IProductAPI) => {
    api
      .post("/products", productToBeAdd)
      .then((_) => {
        getProducts();
        toast.success("Product adicionado");
      })
      .catch((_) => {
        toast.error("Erro ao adicionar produto");
      });
  };

  const deleteProduct = (productId: number | undefined) => {
    api
      .delete(`/products/${productId}`)
      .then((_) => {
        getProducts();
        toast.success("Produto deletado");
      })
      .catch((_) => {
        toast.error("Erro ao deletar produto");
      });
  };

  const editProduct = (editedProduct: IProductAPI) => {
    api
      .patch(`/products/${editedProduct.id}`, editedProduct)
      .then((_) => {
        getProducts();
        toast.success("Produto editado");
      })
      .catch((_) => {
        toast.error("Erro ao editar produto");
      });
  };

  return (
    <ProductsContext.Provider
      value={{
        products,
        setProducts,
        addNewProduct,
        deleteProduct,
        editProduct,
        getProducts,
      }}
    >
      {children}
    </ProductsContext.Provider>
  );
};

export const useProducts = () => useContext(ProductsContext);
